import ResearcherProfile  from './ResearcherProfile';
import RespondentProfile from './RespondentProfile';
import ViewProfile from './ViewProfile';
import CreateProfile from './CreateProfile';
import UpdateProfile from './UpdateProfile';

export {ResearcherProfile, RespondentProfile, ViewProfile, CreateProfile, UpdateProfile};